import { AttributeKey } from '@ps/poker-games-tile-mappers';
import classNames from 'clsx';
import React from 'react';

import { Tooltip } from '@swf/poker';

import styles from './Attribute.scss';

interface AttributeProps {
  attributeKey: AttributeKey;
  value: string;
  name?: string;
  icon?: React.ReactNode;
  isSmallDevice?: boolean;
}

const classNameMap = {
  [AttributeKey.ante]: 'ante',
  [AttributeKey.buttonBlind]: 'buttonBlind',
  [AttributeKey.buyIn]: 'buyIn',
  [AttributeKey.running]: 'running',
  [AttributeKey.startTime]: 'startTime'
};

const Attribute: React.FC<AttributeProps> = ({
  attributeKey,
  value,
  icon,
  name,
  isSmallDevice
}) => {
  if (isSmallDevice) {
    return (
      <div className={classNames(styles.attribute, styles[classNameMap[attributeKey]])}>
        <span>{name}</span> {value}
      </div>
    );
  }

  return (
    <Tooltip
      arrowClassName={styles.tooltipArrow}
      tooltipClassName={styles.tooltip}
      content={name}
      placement="top"
    >
      <div className={classNames(styles.attribute, styles[classNameMap[attributeKey]])}>
        {icon} {value}
      </div>
    </Tooltip>
  );
};

export default Attribute;
